import React, { useEffect, useState } from "react";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import {
  LinearProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import DataTable from "./data-table";

export const TicketTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState();
  const [service, setService] = useState();
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [services, setServices] = useState([]);
  const [isServicesLoading, setIsServicesLoading] = useState(true);

  const getServices = async () => {
    setIsServicesLoading(true);
    const { response } = await Helper.Get({
      url: api_Routes.Services.ViewTicketsFilter,
      hasToken: true,
    });
    if (response) {
      setServices(response?.data);
    }
    setIsServicesLoading(false);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    setFiltersChanged(true);
  };

  const handleServiceChange = (event) => {
    setService(event.target.value);
    setFiltersChanged(true);
  };

  const getData = async () => {
    setIsLoading(true);
    const { response, message } = await Helper.Get({
      url: `${
        api_Routes.TicketsAdvertising.View
      }?per_page=${rowsPerPage}&page=${currentPage + 1}${
        status && status !== "null" ? `&status=${status}` : ""
      }${service && service !== "null" ? `&service=${service}` : ""}`,
      hasToken: true,
    });
    if (response) {
      setData(response);
    } else {
      setData([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (filtersChanged) {
      setCurrentPage(0);
      setFiltersChanged(false);
    } else {
      getData();
    }
  }, [filtersChanged, currentPage, rowsPerPage]);

  useEffect(() => {
    getServices();
  }, []);

  return (
    <div>
      {/* Filter Section */}
      <div className="flex justify-between items-center mb-4 gap-4">
        <FormControl fullWidth>
          <InputLabel id="status-select-label">Status</InputLabel>
          <Select
            labelId="status-select-label"
            id="status-select"
            value={status}
            onChange={handleStatusChange}
            label="Status"
            sx={{ textAlign: "start" }}
          >
            <MenuItem value="null">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="complete">Complete</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="service-select-label">
            {isServicesLoading ? "Loading..." : "Service"}
          </InputLabel>
          <Select
            labelId="service-select-label"
            id="service-select"
            value={service}
            onChange={handleServiceChange}
            label={isServicesLoading ? "Loading..." : "Service"}
            sx={{ textAlign: "start" }}
          >
            {!isServicesLoading && <MenuItem value="null">All</MenuItem>}
            {isServicesLoading ? (
              <MenuItem value="null" disabled>
                Loading
              </MenuItem>
            ) : (
              services?.map((item, idx) => {
                return (
                  <MenuItem value={item?.our_service_id} key={idx}>
                    {item?.name}
                  </MenuItem>
                );
              })
            )}
          </Select>
        </FormControl>
      </div>

      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data && data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <DataTable
              data={data?.data}
              setData={setData}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              status={status}
              service={service}
            />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <TablePagination
              page={currentPage}
              className="mt-auto"
              onPageChange={handlePageChange}
              count={data?.pagination?.total_page}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              variant="outlined"
              shape="rounded"
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};
